import { useState, useEffect } from 'react';
import { db } from '@healthdesk/shared-services';

const DEFAULTS = {
  phase2MaxQuestions: 8,
  phase3MaxQuestionsDashboard: 30,
  phase3MaxQuestionsStandalone: 5,
  autoRefreshInterval: 18000,
  ddxStabilityRequired: 3,
  similarityThreshold: 0.4,
};

const DOC_PATH = 'systemConfig/symptomCheckerPhases';

let cachedConfig = null;

/**
 * Fetches Symptom Checker phase configuration from Firestore with hardcoded defaults.
 * Caches in-memory so subsequent mounts don't re-fetch.
 */
export function useSymptomCheckerConfig() {
  const [config, setConfig] = useState(cachedConfig || DEFAULTS);
  const [loading, setLoading] = useState(!cachedConfig);

  useEffect(() => {
    if (cachedConfig) return;
    let cancelled = false;

    db.collection('systemConfig').doc('symptomCheckerPhases').get()
      .then((snap) => {
        if (cancelled) return;
        const data = snap.exists ? snap.data() : {};
        const merged = { ...DEFAULTS };
        for (const key of Object.keys(DEFAULTS)) {
          if (data[key] != null) merged[key] = Number(data[key]);
        }
        cachedConfig = merged;
        setConfig(merged);
      })
      .catch(() => {
        if (!cancelled) setConfig(DEFAULTS);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, []);

  return { config, loading, DEFAULTS };
}
